import {
  AuthResource,
  SignUpResource,
  ActivateAccountResource,
  MySelfResource,
  ForgotPasswordResource,
  ResetPasswordResource,
  CreatePersonResource,
  PersonResource,
  PersonDeleteResource,
  PersonUpdateResource,
  PersonDeactivateResource,
  PersonHistoryResource,
  EventCreateResource,
  EventResource,
  EventDeleteResource,
  EventUpdateResource,

  UserResource,
  UserCreateResource,
  UserReadResource,
  UserUpdateResource,
  UserDeleteResource,

  SectionResource,
  SectionCreateResource,
  SectionUpdateResource,

} from "./resources";

export default {
  authenticate({ email, password }) {
    return AuthResource.save({}, { email, password });
  },
  mySelf() {
    return MySelfResource.get();
  },
  /*signUp({ email, password, displayname, fullname }) {
    return SignUpResource.save({}, { email, password, displayname, fullname });
  },*/
  signUp(user) {
    return SignUpResource.save({}, user);
  },
  activateAccount({ token }) {
    return ActivateAccountResource.get({ token }, {});
  },
  forgotPassword({ email }) {
    return ForgotPasswordResource.save({ email });
  },
  resetPassword(obj) {
    return ResetPasswordResource.save({}, obj);
  },
  createPerson(person) {
    return CreatePersonResource.save({},person);
  },
  getPersons() {
    return PersonResource.get();
  },
  getPersonHistory(id) {
    return PersonHistoryResource.get({ id }, {});
  },
  deletePerson(id) {
    return PersonDeleteResource.delete({ id }, {});
  },
  deactivatePerson(id) {
    return PersonDeactivateResource.update({ id }, {});
  },
  updatePerson(person) {
    return PersonUpdateResource.update({ id: person._id }, person);
  }, 
  getUsers() {
    return UserResource.get();
  },
  createUser(user) {
    return UserCreateResource.save({},user);
  },
  readUser({id}){
    return UserReadResource.get({id}, {});
  },
  deleteUser(id) {
    return UserDeleteResource.delete({ id }, {});
  },
  updateUser(user) {
    return UserUpdateResource.update({ id: user._id }, user);
  }, 
  getEvents(query) {
    return EventResource.get(query, {});
  },
  deleteEvent(id) {
    return EventDeleteResource.delete({ id }, {});
  },
  updateEvent(event) {
    return EventUpdateResource.update({ id: event._id }, event);
  }, 
  createEvent(event) {
    return EventCreateResource.save({},event);
  },
  getSections() {
    return SectionResource.get();
  },
  createSection(section) {
    return SectionCreateResource.save({},section);
  },
  updateSection(section) {
    return SectionUpdateResource.update({ id: section._id }, section);
  }, 
};
